<div class="theme-asset-by-day-inline">

  <h4 *ngIf="field?.label" class="field-label">{{field.label}}</h4>

  <div *ngIf="sortedRows.length > 0" class="rows-list p-mb-3">
    <div *ngFor="let row of sortedRows" class="theme-asset-row">
      <span class="day-badge">Day {{ row.day }}</span>
      <span class="theme-asset-name">
        {{ getThemeAssetName(row) }}<span *ngIf="row.themeAsset_ref?.id"> ({{ row.themeAsset_ref.id }})</span>
      </span>
      <p-button
        *ngIf="!readonly"
        icon="pi pi-times"
        styleClass="p-button-text p-button-danger p-button-sm remove-btn"
        (onClick)="removeRow(row.day)"
      ></p-button>
    </div>
  </div>
  <p *ngIf="sortedRows.length === 0" class="p-text-secondary p-mb-3" style="font-size:0.875rem;">
    No days configured yet.
  </p>

  <div *ngIf="!readonly" class="p-d-flex p-ai-center p-mb-3" style="gap: 0.75rem;">
    <p-inputNumber
      [(ngModel)]="newDay"
      placeholder="Day"
      [min]="1"
      [showButtons]="false"
      [style]="{'width': '100px'}"
    ></p-inputNumber>

    <p-autoComplete
      [(ngModel)]="newThemeAsset"
      [suggestions]="searchResults"
      (completeMethod)="searchThemeAssets($event)"
      (onSelect)="selectThemeAsset($event)"
      [field]="'name'"
      placeholder="Search theme assets..."
      [style]="{'width': '280px'}"
      [inputStyle]="{'width': '100%'}"
      appendTo="body"
    >
      <ng-template let-t pTemplate="item">
        <span>{{ t.name }}<span *ngIf="t.id" style="color:#868e96; margin-left:0.4rem;">({{ t.id }})</span></span>
      </ng-template>
    </p-autoComplete>

    <p-button
      label="+ Add Day"
      styleClass="p-button-outlined p-button-sm"
      (onClick)="addRow()"
    ></p-button>
  </div>

  <small *ngIf="!readonly && errorMessage" class="p-error" style="display:block; margin-bottom: 0.5rem;">
    {{ errorMessage }}
  </small>

</div>
